import TrustAndSafety from '@/docs-partials/trust-and-safety';
import * as React from 'react';
export default {
  TrustAndSafety,
  React
};